<template>
  <main>
    <div class="main">
      <dl class="titleTip">
        <dt>
          <span>{{ title }}</span>
        </dt>
        <dd></dd>
      </dl>
      <ul class="ulBox">
        <li
          @click.stop="toArticleDetailsPage(item.id, item)"
          v-for="item in articleList"
          :key="item.articleId"
        >
          <div>
            <h2>{{ item.name }}</h2>
            <span>{{ item.time }}</span>
          </div>
        </li>
      </ul>
      <!-- 分页器 -->
      <!--<Pager :countNumber.sync="countNumber"
             :currentPage.sync="currentPage"
             :pagesizeList.sync="pagesizeList"
             :pagesize.sync="pagesize"></Pager>-->
    </div>
  </main>
</template>
<script>
import Pager from "../../components/Pager/Pager";

export default {
  components: {
    Pager: Pager,
  },
  created() {
    this.changeRoute();
  },
  data() {
    return {
      articleList: [],
      // 分页器
      countNumber: 0,
      currentPage: 1, // 当前页数
      pagesizeList: [5, 10, 20, 50, 100],
      pagesize: 5,
      title: "指南规范",
    };
  },
  methods: {
    changeRoute() {
      let query = this.$route.query;
      let youth = query.youth;
      if (youth) {
        this.title = "青年核医说";
      } else {
        this.title = "指南规范";
      }

      this.getAllArticleListByLimit(youth);
    },
    getAllArticleListByLimit(youth) {
      const start = (this.currentPage - 1) * this.pagesize;
      const params = {
        start: start,
        limit: this.pagesize,
        youth,
      };
      if (
        start < 0 ||
        typeof params.start !== "number" ||
        typeof params.limit !== "number"
      ) {
        return;
      }
      this.$api.getClinicalDataList(params).then((r) => {
        if (r.code === 1) {
          this.countNumber = r.data.countNumber;
          this.articleList = r.data.data;
        } else {
          console.error(r.message);
        }
      });
    },
    toArticleDetailsPage(id, item) {
      if (item.pdfUrl) {
        window.open(item.pdfUrl);
        return;
      }
      this.$router.push({ path: "/ClinincalList?ClinicalId=" + id });
      // let newpage = this.$router.resolve({
      //   path: '/ClinincalList?ClinicalId='+id,
      // })
      // window.open(newpage.href, '_blank');
    },
  },
  watch: {
    currentPage() {
      this.getAllArticleListByLimit();
    },
    pagesize() {
      this.getAllArticleListByLimit();
    },
    "$route.fullPath"() {
      this.changeRoute();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./Clinical.scss";
</style>
